import { Text } from '~/components/atomic';
import { PROJECT } from '~/constants';
import * as S from '../Terms.styled';

export default function TermsOfService() {
  return (
    <S.Container>
      <Text as={'h1'} fontStyle='title.section24_bold' color='content_light_2'>
        {PROJECT} Terms of Service
      </Text>
      <S.Desc>
        These Terms of Service (“Terms of Service” or “ToS”) are intended to
        govern and define the relationship between you and Nation A (“Company,”
        “we,” “our” or “us”), including any and all matters related to rights,
        obligations, liabilities, requirements for membership and miscellaneous
        in relation with the “{PROJECT}” service provided by us.
      </S.Desc>
      <S.Article>
        <S.ArticleTitle>Article 1. Definition</S.ArticleTitle>
        <S.ArticleContent>
          <p>① The terms used in the ToS shall be defined as follows:</p>
          <S.SubSection>
            <ol className='list'>
              <li>
                1. “Member” (sometimes referred to as “you” or “your”) refers to
                an individual who signs up or has enrolled for membership on Hey
                D in accordance with the procedure as stipulated by the Company.
              </li>
              <li>
                2. “Services” collectively refers to any and all services
                provided by the Company regardless of the device on which they
                are arranged, including but not limited to personal computers
                (PCs), televisions, handheld devices, various wired and wireless
                devices such as telecommunication equipment.
              </li>
              <li>
                3. “User” refers to all persons who use the website and services
                owned by the Company, regardless of whether or not they have
                signed up, including Members and visitors.
              </li>
              <li>
                4. “App” refers to the {PROJECT} Mobile Application provided by
                the Company.
              </li>
            </ol>
          </S.SubSection>
          <p>
            ② Other terms not separately defined in the ToS shall be as set
            forth in the applicable laws, regulations, and general practice.
          </p>
        </S.ArticleContent>
      </S.Article>
      <S.Article>
        <S.ArticleTitle>
          Article 2. Effect of ToS and Operating Policies
        </S.ArticleTitle>
        <S.ArticleContent>
          <p>
            ① These ToS shall take effect when the Member agrees to the ToS.
          </p>
          <p>
            ② Matters not stipulated in these ToS shall be governed by the
            relevant laws and regulations, including but not limited to “Act on
            the Regulation of Terms and Conditions,” “Act on Promotion of
            Information and Communications Network Utilization and Data
            Protection, etc.” (“IP Network Act”), “Framework Act on Consumers,”
            “Act on the Consumer Protection in Electronic Commerce,” “Framework
            Act on Electronic Documents and Transactions” and “Personal
            Information Protection Act,” as well as the Company’s Operating
            policies.
          </p>
          <p>
            ③ Company may establish and operate Member Operating Policy for
            details related to the ToS, and such Operating Policy shall apply to
            Members in addition to these ToS.
          </p>
          <p>
            ④ If we newly establish or modify the operating policy in the manner
            that the rights or obligations of the Member may be significantly
            affected or the same results may be expected as those caused by
            revision of these ToS, the Company shall follow the procedures set
            forth in Article 2, Paragraphs 3, and 4. However, if the operating
            policy falls under any of the following subparagraphs, it shall be
            replaced by disclosing its content on the Notices:
          </p>
          <S.SubSection>
            <ol className='list'>
              <li>
                1. When the rights and obligations of the Member will be not
                affected or only slightly affected by the newly established or
                modified operating policy; or
              </li>
              <li>
                2. When the operating policy is newly established or modified to
                the extent that its provisions are not essentially different
                from those set forth in these ToS and sufficiently foreseeable
                to the Members.
              </li>
            </ol>
          </S.SubSection>
        </S.ArticleContent>
      </S.Article>
      <S.Article>
        <S.ArticleTitle>Article 3. Subscription</S.ArticleTitle>
        <S.ArticleContent>
          <p>
            ① Individual who intends to sign up to use the {PROJECT} shall
            submit the prescribed application form as set forth by the Company,
            and then read these ToS and clearly show their agreement. In this
            case, the Company may refer to an accredited institution to verify
            the Member’s identity.
          </p>
          <p>
            ② Company may not accept or refuse enrollment of the application
            falling under any of the following:
          </p>
          <S.SubSection>
            <ol className='list'>
              <li>1. When a child under 14 has tried to sign up;</li>
              <li>
                2. When the application form contains false, wrong or omitted
                information, provided that you may still sign up if you write
                and submit again the application form containing all required
                information or with errors corrected; or
              </li>
              <li>
                3. When your membership has been canceled in violation of these
                ToS.
              </li>
            </ol>
          </S.SubSection>
          <p>
            ③ You shall promptly access and edit their personal details at any
            time if they are different from those provided by you when signing
            up or edited thereafter. Company shall not be liable for loss or
            damage caused by your failure to edit personal details
            appropriately, unless otherwise it is caused due to our willful
            misconduct or gross negligence.
          </p>
        </S.ArticleContent>
      </S.Article>
      <S.Article>
        <S.ArticleTitle>
          Article 4. Management of Personal Information
        </S.ArticleTitle>
        <S.ArticleContent>
          <p>
            ① You shall keep your personal information safe and confidential.
            You are solely responsible for any liability or damages resulting
            from your failure to maintain confidentiality or prohibit
            unauthorized use, for example, if you disclose your personal
            information to or allow a third party to use in the Services.
          </p>
          <p>
            ② Unauthorized use or alteration of the others’ personal information
            acquired from the Company or provided by the other Member during the
            use of the Services for any purpose other than the that for which it
            has been provided are strictly prohibited. You shall not provide or
            disclose it to a third party without the consent of the other
            Members for any purpose, and shall keep such personal information
            strictly confidential so that it is not lost or leaked.
          </p>
          <p>
            ③ You shall not acquire personal information from the Company or
            other Members by any fraudulent, suspicious, criminal, or dishonest
            activity, use the acquired personal information for commercial or
            improper purposes, nor provide it to any third parties.
          </p>
          <p>
            ④ Notwithstanding the previous Paragraph 1, the Company shall be
            liable for any loss or damages arising from our failure to protect
            personal information or gross negligence.
          </p>
        </S.ArticleContent>
      </S.Article>
      <S.Article>
        <S.ArticleTitle>Article 5. Our Privacy Policy</S.ArticleTitle>
        <S.ArticleContent>
          <p>
            ① The term “personal information” referred to herein is information
            as defined in Article 2, Paragraph 1 of the Personal Information
            Protection Act, regardless of the format, whether it is tangible or
            intangible.
          </p>
          <p>
            ② To protect the personal information of Members, the Company
            complies with the provisions of relevant laws and regulations such
            as the Personal Information Protection Act, and establishes our
            “Privacy Policy” regarding the Members’ rights and the processing of
            personal information.
          </p>
        </S.ArticleContent>
      </S.Article>
      <S.Article>
        <S.ArticleTitle>Article 6. Services</S.ArticleTitle>
        <S.ArticleContent>
          <p>① The Services provided by the Company include the followings:</p>
          <S.SubSection>
            <ol className='list'>
              <li>1. Conversation with the AI Companion;</li>
              <li>2. 3D models and motions for the AI Companion; and</li>
              <li>3. Feature for creating a Virtual Human.</li>
            </ol>
          </S.SubSection>
          <p>
            ② Company will be using our best to provide the Services without
            interruption unless there is unavoidable business or technical
            inability, provided that the Services may be temporarily suspended
            with the prior written notice of the Company if it is necessary to
            improve or enhance the service quality, such as regular maintenance
            or upgrade of the system.
          </p>
          <p>
            ③ Company may add, suspend or otherwise revise all or part of the
            Services from time to time due to internal or external changes in
            the environment or Company policies, with the prior written notice
            of details, including but not limited to the detailed revisions,
            reasons for revision and effective date.
          </p>
        </S.ArticleContent>
      </S.Article>
      <S.Article>
        <S.ArticleTitle>Article 7. Suspension of Services</S.ArticleTitle>
        <S.ArticleContent>
          <p>
            ① Company may temporarily suspend all or part of the Services if the
            Company is unable to provide the Services due to force majeure
            events or other events beyond our control, including but not limited
            to technical failures (including breaches caused by external factors
            such as malicious cyberattacks), external circumstances not
            attributable to the Company (such as emergency blackout or system
            failure caused by telecommunication service providers), or natural
            disasters.
          </p>
          <p>
            ② If we receive a decision or request from an investigative agency,
            court, the Korea Communications Commission or other authorities, the
            Company may take measures such as suspension without prior notice or
            announcement to the Members, and notify the Members of the specified
            reasons after the end of the procedure.
          </p>
          <p>
            ③ Company shall not be liable for any damages or losses incurred by
            the Members if the Company suspends the Services pursuant to the
            preceding Paragraphs 1 and 2.
          </p>
          <p>
            ④ In the event that the Company (or surviving company after merger)
            is unable to provide the Services for reasons including but not
            limited to business conversion, abandonment or merge, we will notify
            the Members of discontinuation and follow-up actions in advance and
            endeavor to prevent the Members from suffering losses.
          </p>
        </S.ArticleContent>
      </S.Article>
      <S.Article>
        <S.ArticleTitle>Article 8. Obligations of Members</S.ArticleTitle>
        <S.ArticleContent>
          <p>① Upon using the {PROJECT} Services, the Members shall not:</p>
          <S.SubSection>
            <ol className='list'>
              <li>
                1. Provide false, wrong or omitted information when signing up
                or editing the personal details;
              </li>
              <li>
                2. unauthorizedly use name or personal data owned by any third
                party (identity theft);
              </li>
              <li>
                3. impersonate any of the Company’s operators, employees or
                representatives, or otherwise take our name and information in
                our possession without our permission;
              </li>
              <li>4. modify or alter information published by the Company;</li>
              <li>
                5. post or transmit to others any data that contains software
                viruses or any other malicious codes, files or programs that
                have the potential to interrupt or destroy the normal operation
                of any computer software, hardware, or telecommunications
                equipment;
              </li>
              <li>
                6. use automated devices (macros, bots, spiders or scrapers) to
                attempt to or actually sign up for membership without the prior
                permission of the Company; collect, process, or distribute
                information that may be obtained through the Services; use the
                Services in a manner that is deemed outside the spirit and
                intent of the Services; or attempt to neutralize the Company’s
                measures to prevent abusive behaviors on the Services;
              </li>
              <li>
                7. post or distribute any material infected with a computer
                virus that is likely to damage, tamper with or corrupt the
                stable operation of the Services;
              </li>
              <li>
                8. infringe the intellectual property rights owned by the
                Company or any third parties, including but not limited to
                copyrights, trade secrets and patent rights;
              </li>
              <li>
                9. act with intent to annoy, harass, defame, threaten or abuse
                the Company, other Members or any third parties;
              </li>
              <li>
                10. disclose or post obscene or violent messages, or other
                information that is against social customs and public morals;
              </li>
              <li>11. hack to obtain other Users’ information;</li>
              <li>
                12. use the Services for any commercial, sales, advertising,
                political, or other activity without our consent; and/or
              </li>
              <li>
                13. engage in any other illegal behavior that violates current
                laws and public morals, or any inappropriate, uncooperative,
                disruptive, fraudulent, potentially fraudulent, or socially
                unacceptable behavior or activity.
              </li>
            </ol>
          </S.SubSection>
          <p>
            ② In particular, when creating a virtual avatar, the Members shall
            not engage in any act that defames the reputation of a third party,
            nor engage in unfair competition by unauthorized use of the name,
            portrait, voice, signature, or other marks corresponding to
            personally identifiable information, which are widely recognized in
            Korea and have economic values under Article 2, Item 1 of the
            “Unfair Competition Prevention And Trade Secret Protection Act.”
          </p>
          <p>
            ③ If you engage in any of the acts defined in the preceding
            Paragraphs 1 and 2 (hereinafter referred to as “Prohibited
            Behaviors”), the Company reserves the right in its sole discretion
            to take reasonable measures, including but not limited to
            prohibition of your engagement in the Services, revocation of
            membership, or referral to an investigative agency, depending on the
            severity.
          </p>
          <p>
            ④ You shall be solely liable for damages to the Company, other
            Members or any third parties by engaging in any of the Prohibited
            Behaviors described in Paragraphs 1 and 2, if any, unless otherwise
            it is caused due to our willful misconduct or gross negligence.
          </p>
        </S.ArticleContent>
      </S.Article>
      <S.Article>
        <S.ArticleTitle>Article 9. Restriction of Use</S.ArticleTitle>
        <S.ArticleContent>
          <p>
            ① Company may temporarily freeze your account if it is necessary to
            protect the rights and interests of other Member and maintain the
            stable operation of the Service, such as when your account is
            directly or indirectly involved in a specific violation, in the
            process of investigating a violation of the “Obligations of Members”
            as set forth in these ToS.
          </p>
          <p>
            ② Company may restrict the membership or suspend the use of the
            Services for a period of time with prior written notice if you
            violate the provisions of Article 9 (Obligations of Members) in
            these ToS and damage and undermine the legitimate operation of the
            Services.
          </p>
          <p>
            ③ Notwithstanding the preceding paragraph, the Company may
            immediately and permanently freeze your account if we determine that
            you have committed or participated in violation of the relevant
            laws, including but not limited to provision of illegal programs in
            violation of copyright laws, disruption of legitimate operation,
            illegal communication and hacking in violation of the “IP Network
            Act”, distribution of malicious programs, abuse of access rights,
            and unfair competition under the “Unfair Competition Prevention And
            Trade Secret Protection Act”.
          </p>
          <p>
            ④ Company may restrict the use of the Services to keep or control
            your personal data and to ensure operational efficiency if you does
            not sign in for more than one year.
          </p>
          <p>
            ⑤ If you want to raise an objection against the Company’s
            restriction of use pursuant to the provisions of this Article, you
            submit an objection in writing, by e-mail or any of equivalent
            channels, stating the reasons why the Company should withdraw the
            restriction within 15 days from the date of receipt. Upon receipt of
            the objection, the Company shall respond to your objection in
            writing, by e-mail or any of equivalent channels, within 15 days
            from the date of receipt, and take corresponding measures, provided
            that, however, if the Company is unable to respond within 15 days,
            the Company shall notify you of the reason and the updated schedule.
          </p>
        </S.ArticleContent>
      </S.Article>
      <S.Article>
        <S.ArticleTitle>
          Article 10. Deletion or Restriction of Use of AI Avatars
        </S.ArticleTitle>
        <S.ArticleContent>
          <p>
            ① Company may remove the post or limit, suspend, or terminate your
            membership if the AI avatar created by you:
          </p>
          <S.SubSection>
            <ol className='list'>
              <li>
                1. slanders or defames other Members or any third parties;
              </li>
              <li>
                2. discloses or distributes obscene, violent or disruptive
                information, sentences or images, which are against social
                customs and public morals;
              </li>
              <li>
                3. engages in suspicious or criminal activity deemed in the sole
                discretion of the Company;
              </li>
              <li>
                4. infringes or violates the rights owned by the other Members
                or any third parties, including but not limited to copyrights;
              </li>
              <li>
                5. causes religious or political dispute and the Company deems
                that your behaviors will or may damage or undermine our
                legitimate operation;
              </li>
              <li>
                6. invades the privacy and personal life of others or defames
                them;
              </li>
              <li>
                7. fails to fulfill the purpose of posting, such as posting
                duplicates of the same content;
              </li>
              <li>
                8. posts unnecessary or unauthorized advertisements or
                promotions; and/or
              </li>
              <li>
                9. contains the content which we deems inappropriate for the
                bulletin at our sole discretion.
              </li>
            </ol>
          </S.SubSection>
          <p>
            ② If another Member or a third party takes legal action (e.g.
            lawsuit, injunction, or claim for damages) against you or the
            Company based on an infringement of legal interests caused by your
            postings, and requests the removal of the corresponding postings,
            the Company may temporarily restrict the rights to access, edit or
            delete the relevant posting pending the outcome of such legal action
            (e.g. prosecution, preliminary injunction, or damages award).
          </p>
        </S.ArticleContent>
      </S.Article>
      <S.Article>
        <S.ArticleTitle>Article 11. Posting and Amendment</S.ArticleTitle>
        <S.ArticleContent>
          <p>
            ① We will post these ToS on the App or Website’s main page so that
            you can easily access them.
          </p>
          <p>
            ② These ToS may be amended, revised or altered to the extent
            permitted by the relevant laws and regulations with justifiable
            reasons.
          </p>
          <p>
            ③ If the Company amends or revises the ToS pursuant to the preceding
            Paragraph 2, the Company will notify the details of the amendment
            and the effective date at least 7 days before the effective date,
            provided that, however, if the amendment will significantly affect
            the rights and obligations of the Members or is unfavorable to the
            Members, the Company shall notify them by a 30-day prior written
            notice on the App or Website and send a communication to each Member
            with the contact information provided by the Member.
          </p>
          <p>
            ④ Although the Company notifies the Member of the amended ToS
            pursuant to the Paragraph 3 and makes it clear that the Member will
            be deemed to have agreed to the amended ToS unless they expressly
            indicates intention to disagree by the Effective Date, the Member
            does not clearly express the intention of disagreement, the amended
            ToS will apply as they are deemed to have agreed to the amended ToS.
          </p>
          <p>
            ⑤ In the event that the Member does not agree with the amendment,
            they are entitled to stop using the Service and request a refund
            from the Company.
          </p>
          <p>
            ⑥ The amended ToS made under the provision of this Article shall be
            effective as of the Effective Date.
          </p>
        </S.ArticleContent>
      </S.Article>
      <S.Article>
        <S.ArticleTitle>Article 12. Cancellation</S.ArticleTitle>
        <S.ArticleContent>
          <p>
            ① If the Member intends to cancel the membership, they may make a
            request for cancellation to the Company at any time; in such a case,
            the Company accept the request immediately according to the
            procedure the Company has notified separately.
          </p>
          <p>
            ② If the Member withdraws from the Services, they will lose the
            right to edit or delete any posts they have saved on the Services.
            Therefore, you shall delete all posts created and posted by you
            before withdrawing from the Services, provided that, however, if the
            work was created through collaborative authorship, the post may be
            remained on the Company’s Service Archive at the will of the
            co-authors. If the work is stored by a third party or reproduced
            through unauthorized copy and reposted without being deleted, the
            Company will take measures such as deletion of the work at the
            request of the actual right holder.
          </p>
          <p>
            ③ In the event that you commit violation of these ToS, related laws
            or regulations, the Company may retain your account information to
            the extent permitted by relevant laws and regulations even after you
            cancel the membership in order to protect other Members and to be
            used as evidence upon request by courts, investigative agencies or
            related authorities.
          </p>
        </S.ArticleContent>
      </S.Article>
      <S.Article>
        <S.ArticleTitle>Article 13. Disclaimer</S.ArticleTitle>
        <S.ArticleContent>
          <p>
            ① COMPANY SHALL NOT BE LIABLE FOR ANY FAILURE TO USE THE SERVICES
            DUE TO REASONS ATTRIBUTABLE TO YOU, SUCH AS YOUR FAILURE TO COMPLY
            WITH THE TOS, SERVICE REQUIREMENTS AND STANDARDS, OR DUE TO COMPUTER
            ERRORS.
          </p>
          <p>
            ② COMPANY IS NOT OBLIGATED TO INTERVENE IN ANY DISPUTES ARISING FROM
            THE MEDIATION OF THE SERVICES BETWEEN MEMBERS OR BETWEEN MEMBER AND
            ANY THIRD PARTY, AND SHALL NOT BEAR ANY RESPONSIBILITY FOR DAMAGES
            RESULTING THEREFROM.
          </p>
          <p>
            ③ COMPANY SHALL NOT BE LIABLE FOR THE USE OF SERVICES PROVIDED FREE
            OF CHARGE UNLESS OTHERWISE PROVIDED BY APPLICABLE LAWS.
          </p>
          <p>
            ④ COMPANY SHALL BE RELEASED FROM LIABILITY IF IT IS UNABLE TO
            PROVIDE THE SERVICES DUE TO NATURAL DISASTERS, WAR, SERVICE
            SUSPENSION BY TELECOMMUNICATIONS CARRIERS, AUTHENTICATION FAILURE OF
            OPENID PROVIDED BY A THIRD PARTY, TECHNICAL DEFECTS THAT ARE
            DIFFICULT TO SOLVE, OR OTHER FORCE MAJEURE EVENTS.
          </p>
          <p>
            ⑤ COMPANY SHALL NOT BE LIABLE FOR ANY INTERRUPTION OR FAILURE OF THE
            SERVICES DUE TO UNAVOIDABLE REASONS SUCH AS REPAIR, REPLACEMENT,
            REGULAR INSPECTION OR CONSTRUCTION OF THE FACILITIES FOR THE
            SERVICES WHICH ARE NOTIFIED IN ADVANCE.
          </p>
          <p>
            ⑥ YOU SHALL BE SOLELY RESPONSIBLE FOR ANY DAMAGES TO THE COMPUTER
            SYSTEM OR LOSS OF DATA OR INFORMATION CAUSED BY DOWNLOADING OR
            ACCESSING SPECIFIC PROGRAMS OR INFORMATION USING THE COMPANY’S
            SERVICES AT YOUR OWN DISCRETION.
          </p>
          <p>
            ⑦ COMPANY SHALL NOT BE LIABLE FOR ANY PROBLEMS ARISING FROM YOUR
            COMPUTER ENVIRONMENT OR SECURITY ISSUES BEYOND OUR CONTROL, OR ANY
            PROBLEMS THAT OCCUR NOT DUE TO OUR WILLFUL MISCONDUCT OR GROSS
            NEGLIGENCE, SUCH AS NETWORK HACKING THAT IS DIFFICULT TO DEFEND
            AGAINST WITH THE CURRENT LEVEL OF SECURITY TECHNOLOGY.
          </p>
          <p>
            ⑧ COMPANY DOES NOT WARRANT OR ASSUME RESPONSIBILITY FOR THE
            ACCURACY, CONTENT, COMPLETENESS, LEGALITY OR RELIABILITY OF ANY
            INFORMATION PROVIDED BY THE SERVICES, AND BEAR NO RESPONSIBILITY FOR
            DELETION, FAILURE TO STORE, MISDIRECTION, OR PROVISION OF
            INFORMATION ON THE WEBSITE. COMPANY IS NOT RESPONSIBLE FOR THE
            RELIABILITY, ACCURACY, COMPLETENESS AND QUALITY OF ANY INFORMATION,
            MATERIALS, OR FACTS POSTED OR TRANSMITTED BY MEMBERS WITHIN THE
            SERVICES OR ON THE WEBSITE.
          </p>
          <p>
            ⑨ COMPANY SHALL NOT BE LIABLE FOR YOUR FAILURE TO OBTAIN THE
            EXPECTED OUTCOMES BY USING THE SERVICES, AND SHALL BE RELEASED FROM
            LIABILITY FOR ANY DAMAGES ARISING FROM YOUR CHOICE OR USE OF THE
            SERVICES.
          </p>
          <p>
            ⑩ COMPANY IS NOT OBLIGATED TO SCREEN THE MEMBERS’ POSTS OR THE
            AVATARS CREATED BY THE MEMBERS BEFORE REGISTRATION OR REVIEW THE
            CONTENTS OF THE POSTS AT ANY TIME, AND BEAR NO RESPONSIBILITY FOR
            THE RESULTS THEREFROM.
          </p>
          <p>
            ⑪ COMPANY MAY LIMIT THE HOURS OF USE OF THE SERVICES DEPENDING ON
            THE SERVICES OR MEMBERS IN ACCORDANCE WITH APPLICABLE LAWS AND
            GOVERNMENT POLICIES, AND SHALL BE RELEASED FROM LIABILITY FOR ALL
            MATTERS RELATED TO THE SERVICES ARISING FROM SUCH RESTRICTIONS AND
            LIMITATIONS.
          </p>
        </S.ArticleContent>
      </S.Article>
      <S.Article>
        <S.ArticleTitle>Article 14. Notice</S.ArticleTitle>
        <S.ArticleContent>
          <p>
            ① If it is necessary to notify all members, the Company will notify
            them through the bulletin in the App or Website, provided that
            matters that are unfavorable to Members or affect their rights or
            obligations, and matters that need to be notified to specific
            Members will be notified individually to the contact information
            they have provided.
          </p>
          <p>
            ② You shall ensure that your membership information is kept updated
            after signing up or editing the personal details, and if you fail to
            this and cannot receive a notice or other communications from the
            Company, you shall solely bear all responsibility unless otherwise
            unless otherwise it is caused due to our willful misconduct or gross
            negligence.
          </p>
        </S.ArticleContent>
      </S.Article>
      <S.Article>
        <S.ArticleTitle>
          Article 15. Dispute Resolution and Jurisdiction
        </S.ArticleTitle>
        <S.ArticleContent>
          <p>
            ① If a dispute arises between the Company and the Member in relation
            with any matter not stipulated in these ToS or the ToS, dispute
            shall be settled by amicable negotiation therebetween, and if no
            agreement is reached, it shall be governed by relevant laws and
            general customs.
          </p>
          <p>
            ② In the event of the dispute that cannot be resolved in accordance
            with the preceding Paragraph 1, or if a lawsuit is filed regarding a
            dispute arising from the use of the Services provided by the
            Company, the jurisdiction of the court shall be governed by the
            jurisdictional provisions of the Civil Procedure Law.
          </p>
        </S.ArticleContent>
      </S.Article>
      <S.Article>
        <S.ArticleContent>
          <p>[Addendum]</p>
          <p>The ToS shall be effective from May ., 2024.</p>
        </S.ArticleContent>
      </S.Article>
    </S.Container>
  );
}
